"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpExcludeOptions = void 0;
var IpExcludeOptions = /** @class */ (function () {
    function IpExcludeOptions() {
    }
    return IpExcludeOptions;
}());
exports.IpExcludeOptions = IpExcludeOptions;
